import { gql, TypedDocumentNode } from "@apollo/client";

import { Query } from "types/generated";

type FetchEnabledCloudIntegrationsData = {
  awsIntegrationsEnabled: Query["awsIntegrationsEnabled"];
  azureIntegrationsEnabled: Query["azureIntegrationsEnabled"];
};

export const GET_ENABLED_CLOUD_INTEGRATIONS: TypedDocumentNode<FetchEnabledCloudIntegrationsData> = gql`
  query GetEnabledCloudIntegrations {
    awsIntegrationsEnabled
    azureIntegrationsEnabled
  }
`;
